import { render, staticRenderFns } from "./ViewEnforcement.vue?vue&type=template&id=0f8aba64"
import script from "./ViewEnforcement.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEnforcement.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports